import { NavigationClient } from "@azure/msal-browser";
import type { Router, RouteRecordRaw } from "vue-router";
import type { NavigationOptions } from "@azure/msal-browser";

/**
 * Create hook route
 */
export function hook (path: string, callback: () => Promise<unknown>): RouteRecordRaw {
  return {
    path,
    component: { render: () => null },
    beforeEnter: async () => {
      const result = await callback();
      return result !== undefined;
    },
  };
}

/**
 * Override MSAL route navigation
 */
export class VueNavigationClient extends NavigationClient {
  private readonly router: Router;

  constructor(router: Router) {
    super();
    this.router = router;
  }

  /**
   * Only called during redirects
   */
  navigateExternal(url: string, options: NavigationOptions): Promise<boolean> {
    return super.navigateExternal(url, options);
  }

  /**
   * Only called during popup completion
   */
  async navigateInternal(
    url: string,
    options: NavigationOptions,
  ): Promise<boolean> {
    const path = url.replace(location.origin, "");
    if (options.noHistory) {
      await this.router.replace(path);
    } else {
      await this.router.push(path);
    }
    return true;
  }
}
